module.exports = __webpack_public_path__ + "img/tarjeta-credito.7a052162.svg";